import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../authentication/authentication.service';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UnauthorizedComponent implements OnInit {
    expirado = false;

    constructor(
        private router: Router,
        private authService: AuthenticationService,
        private modalService: NgbModal,
        private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.modalService.dismissAll();
        this.route.params.subscribe(params => {
            (params.errorCode && params.errorCode === '401') ? this.expirado = true : this.expirado = false;
        });
    }

    tryLogin() {
        this.authService.resetToken();
        this.router.navigate(['']);
    }
}
